import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from 'primeng/toolbar';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { Table, TableContextMenuSelectEvent, TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
@Component({
    selector: 'app-team',
    imports: [
        CommonModule,
        ToolbarModule,
        RouterModule,
        TableModule,
        FormsModule,
        ButtonModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        MultiSelectModule
    ],
    templateUrl: './team.component.html',
    styleUrls: ['./team.component.scss']
})
export class TeamComponent {
  // Add this property inside the TeamComponent class
@ViewChild('teamMembersField') teamMembersField!: ElementRef;
    teams = [
        {
            id: 1,
            teamName: 'Development Team',
            teamLead: 'Alice',
            membersCount: 5,
            project: 'Project A',
            members: [
                { name: 'Alice', role: 'Developer' },
                { name: 'Bob', role: 'Tester' }
            ]
        },
        {
            id: 2,
            teamName: 'QA Team',
            teamLead: 'Bob',
            membersCount: 3,
            project: 'Project B',
            members: [
                { name: 'Charlie', role: 'QA Engineer' },
                { name: 'David', role: 'QA Lead' }
            ]
        },
        {
            id: 3,
            teamName: 'Design Team',
            teamLead: 'Charlie',
            membersCount: 4,
            project: 'Project C',
            members: [
                { name: 'Eve', role: 'Designer' },
                { name: 'Frank', role: 'UX Specialist' }
            ]
        }
    ];

    selectedTeams: any[] = [];

    constructor(private router: Router) {}

    editTeam(team: any) {
        alert(`Editing team: ${team.teamName}`);
    }

    deleteTeam(team: any) {
        this.teams = this.teams.filter((t) => t.id !== team.id);
        alert(`Deleted team: ${team.teamName}`);
    }

    openTeamDetails(team: any) {
        this.router.navigate(['/team-details', team.id], { state: { team } });
    }

    editProduct(_t67: any) {
        throw new Error('Method not implemented.');
    }
    selectedCustomer: any;
    onRightClick($event: MouseEvent, _t67: any) {
        throw new Error('Method not implemented.');
    }
    onGlobalFilter(_t24: Table<any>, $event: Event) {
        throw new Error('Method not implemented.');
    }
    selectedProducts: any;
    onRowSelect($event: TableContextMenuSelectEvent<any>) {
        throw new Error('Method not implemented.');
    }
    cm: unknown;
    products(): any[] {
        throw new Error('Method not implemented.');
    }
    New() {
      this.isCreatingNewTeam=true;
    
    }
    // teams = [
    //   { name: 'Team A', members: [{ name: 'Alice' }, { name: 'Bob' }] },
    //   { name: 'Team B', members: [{ name: 'Charlie' }, { name: 'David' }] }
    // ];

    selectedTeam: any = null;

    selectTeam(team: any) {
        this.selectedTeam = team;
    }

    openPanel(team: any) {
        this.selectedTeam = team;
    }

    closePanel() {
        this.selectedTeam = null;
    }

    assignTask(member: any) {
        alert(`Task assigned to ${member.name}`);
    }

    headerPanelOpen: boolean = false;
    team = {
        teamName: 'Sales Team',
        teamLead: 'Jane Smith',
        project: 'Client Acquisition',
        members: [
            { name: 'Alice', role: 'Sales Executive', region: 'North America', targetAchieved: '80%', status: 'Active' },
            { name: 'Bob', role: 'Account Manager', region: 'Europe', targetAchieved: '90%', status: 'Active' },
            { name: 'Charlie', role: 'Sales Analyst', region: 'Asia', targetAchieved: '70%', status: 'Inactive' }
        ],
        companyValuation: 5000000,
        teamValuation: 1000000,
        quarterlyRevenue: 250000,
        annualRevenue: 1000000,
        region: 'Global'
    };

    toggleHeaderPanel() {
        this.headerPanelOpen = !this.headerPanelOpen;
    }

    isCreatingNewTeam: boolean = false;
    newTeam: any = {
        teamName: '',
        teamLead: '',
        project: '',
        members: ''
    };

    submitted: boolean = false;

    hideDialog() {
        this.isCreatingNewTeam = false;
        this.submitted = false;
    }

    manageTeamTable: any[] = [];

    saveNewTeam() {
      this.submitted = true;
      if (!this.newTeam.teamName || !this.newTeam.teamLead || !this.newTeam.project || !this.newTeam.members || this.newTeam.members.length === 0) {
        alert('Please fill in all required fields.');
        return;
      }
    
      console.log('Saving team:', this.newTeam.teamName);
    
      const teamData = {
        id: this.teams.length + 1, // Generate a unique ID based on the array length
        teamName: this.newTeam.teamName,
        teamLead: this.newTeam.teamLead,
        membersCount: this.newTeam.members.length,
        project: this.newTeam.project,
        members: this.newTeam.members.map((member: any) => ({ name: member, role: 'Member' }))
      };
    
      this.teams.push(teamData); // Save the new team in the teams array
      alert('Team created successfully!');
    
      console.log('Team saved:', teamData);
    
      this.isCreatingNewTeam = false;
      this.newTeam = { teamName: '', teamLead: '', project: '', members: [] }; // Reset form
    }

    availableMembers: any[] = [
        { label: 'John Doe', value: 'john_doe' },
        { label: 'Jane Smith', value: 'jane_smith' },
        { label: 'Michael Brown', value: 'michael_brown' },
        { label: 'Emily Davis', value: 'emily_davis' }
    ];
}
